import React from "react";
import SliderImagenes from "../../../Resultados/ListadoProducto/ProductoCuadro/SliderImagenes";
import Contenido from "./Contenido";
import Precio from "./Precio";
import { withRouter } from "react-router-dom";
import get from "../../../../utils/get";
import Regimenes from "./regimenes";
import Camas from "./camas";


const ProductoCuadro = (props) => {
  const { 
    producto, 
    onCombinacionDeCamaClick, 
    onRegimenSeleccionadoClick, 
    cantidadHabitacionesSolicitadas 
  } = props;
  const { hotel } = producto;
  const imagenes = hotel.multimedia.filter(m => m.tipoArchivo === 'I').map(m => m.url);
  
  return (
    <div className="result" id="result-1">
      <div className="row">
        {/*SLIDER*/}
        <SliderImagenes imagenes={imagenes} />
        {/*PARTE CENTRAL*/}
        <Contenido hotel={hotel} />
        {/*PARTE DERECHA*/}
        <Precio producto={producto} />

        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 paquetes-disponibles">
          <ul>
            {cantidadHabitacionesSolicitadas !== producto.habitaciones.length ? 
            <li className="textoHabitaciones">No se han encontrado todas las habitaciones solicitadas. Por favor busque en otras fechas o con otra cantidad de habitación</li>
             : producto.habitaciones.map((habitacion, index) => {
              const combinacionesDeCamas = get(habitacion, 'tipoDeHabitacion.combinaciones', []);
              return (
                <li key={habitacion.idHabitacion} className="row" style={{padding: '10px'}}>
                    <p>Habitacion {index + 1} ({habitacion.tipoDeHabitacion.nombreTipo})</p>
                    <Regimenes 
                      regimenes={producto.regimenes}
                      habitacion={habitacion}
                      idProducto={producto.idProducto}
                      regimenSeleccionado={habitacion.regimenSeleccionado} 
                      onRegimenSeleccionadoClick={onRegimenSeleccionadoClick} 
                    />
                    <Camas 
                      habitacion={habitacion}
                      idProducto={producto.idProducto}
                      combinacionesDeCamas={combinacionesDeCamas} 
                      onCombinacionDeCamaClick={onCombinacionDeCamaClick} 
                    />
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};
//FC: el withRouter es para poder hacer un this.props.history.push('/')
export default withRouter(ProductoCuadro);



// WEBPACK FOOTER //
// ./src/components/Hoteles/ResultadosCdr/ProductoCuadro/index.js